import { render, staticRenderFns } from "./LocalAdsPage.vue?vue&type=template&id=43150e74&scoped=true&lang=pug&"
import script from "./LocalAdsPage.vue?vue&type=script&lang=js&"
export * from "./LocalAdsPage.vue?vue&type=script&lang=js&"
import style0 from "./LocalAdsPage.vue?vue&type=style&index=0&id=43150e74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43150e74",
  null
  
)

/* custom blocks */
import block0 from "./LocalAdsPage.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VContainer,VDivider,VLayout,VProgressCircular,VRow,VTextField})
